import { useSuspenseQuery } from '@tanstack/react-query';

import { useBoundStore } from 'app/store';

import { getHsptlzFormCcrcInfo } from '../api';

export const useGetHsptlzFormCcrcInfo = () => {
  const { hspId, usrId, hsptlzRsvNo } = useBoundStore((state) => state['hsptlzForm'].serviceParams);
  const setProcessFormData = useBoundStore((state) => state['hsptlzForm'].setProcessFormData);
  const setSubmittedFormData = useBoundStore((state) => state['hsptlzForm'].setSubmittedFormData);
  const setRedirectData = useBoundStore((state) => state['hsptlzForm'].setRedirectData);

  const {
    data: { data },
  } = useSuspenseQuery({
    queryKey: ['hsptlzFormCcrcInfo'],
    queryFn: async () => {
      const data = await getHsptlzFormCcrcInfo({ hspId, usrId, hsptlzRsvNo });

      const [processFormData, submittedFormData] = data.data.contentList.reduce(
        (acc, cur) => {
          if (cur.completed === 'N') acc[0][cur.contentCode] = { ...cur, checkInPlace: data.data.checkInPlace };
          else acc[1][cur.contentCode] = { ...cur, checkInPlace: data.data.checkInPlace };
          return acc;
        },
        [{}, {}],
      );

      setRedirectData({
        failMsg:data.data.failMsg
      })
      setProcessFormData(processFormData);
      setSubmittedFormData(submittedFormData);

      return data;
    },
  });

  return { data };
};
